
import { useState } from "react";
import { addDays } from "date-fns";

export function useAutoGenerationDate() {
  const [nextAutoGenerationDate] = useState<Date>(() => {
    // Find next Friday at 5pm
    const now = new Date();
    const dayOfWeek = now.getDay(); // 0-6, 0 is Sunday, 5 is Friday
    const daysToAdd = dayOfWeek <= 5 ? 5 - dayOfWeek : 7 - dayOfWeek + 5;
    const nextFriday = addDays(now, daysToAdd);
    nextFriday.setHours(17, 0, 0, 0); // 5:00 PM
    return nextFriday;
  });

  const runAutoGeneration = () => {
    // Return this function to be implemented in the main hook
    return { nextAutoGenerationDate };
  };

  return {
    nextAutoGenerationDate,
    runAutoGeneration
  };
}
